import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {UpdateAccountTeamMemberResultModal} from './update-account-team-member.result.modal';
import {
    clearResult,
    selectAccountManagerUpdateShown,
    selectAccountManagerUpdateTask,
    selectAccountManagerUpdateUuid,
} from './update-account-team-member.slice';

export const UpdateAccountTeamMemberResult = () => (
    <BulkActionResult
        actionIdSelector={selectAccountManagerUpdateUuid}
        actionTaskSelector={selectAccountManagerUpdateTask}
        actionShownSelector={selectAccountManagerUpdateShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <UpdateAccountTeamMemberResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
